import React, { useCallback, useState } from 'react';

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { CloseCircle, ForwardItem } from 'iconsax-reactjs';
import { toast } from 'react-toastify';

import { sendInformationRequest } from '../../../../api/information-request';
import { ButtonGroupButtonStyled } from '../../styles';

const InformationRequest = React.memo(() => {
  const [isShow, setShow] = useState(false);
  const [isProcess, setProcess] = useState(false);

  const handleSend = useCallback(async () => {
    setProcess(true);

    try {
      await sendInformationRequest();

      toast.success('The request was submitted.');

      setShow(false);
    } finally {
      setProcess(false);
    }
  }, []);

  return (
    <>
      <ButtonGroupButtonStyled
        variant="contained"
        color="primary"
        size="large"
        endIcon={<ForwardItem size={16} />}
        onClick={() => setShow(true)}
      >
        Je m&apos;inscris à la réunion d&apos;information
      </ButtonGroupButtonStyled>

      <Dialog open={isShow}>
        <DialogTitle>EN SAVOIR PLUS</DialogTitle>

        <IconButton
          aria-label="close"
          onClick={() => setShow(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseCircle />
        </IconButton>

        <DialogContent>
          <Stack spacing={1}>
            <Typography variant="md">
              Vous souhaitez en savoir plus sur le programme Mon Coach Mobilité par KINT ?
            </Typography>
            <Typography variant="md">
              Faites-le nous savoir, nous vous contacterons au plus vite pour vous inviter à notre
              prochaine réunion d’information.
            </Typography>
          </Stack>
        </DialogContent>

        <DialogActions>
          {isProcess && <CircularProgress size={24} />}

          {!isProcess && (
            <Button variant="contained" color="primary" onClick={handleSend}>
              Valider
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
});

export default InformationRequest;
